import React from "react";

const DocumentWithLabelIcon: React.FC<DocumentWithLabelIconProps> = ({
  boxSize = 20,
  className,
}) => {
  return (
    <svg
      width={boxSize}
      height={boxSize}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_2967_33526)">
        <path
          d="M5 0.375H11.5938L17.625 6.40625V18C17.625 18.8975 16.8975 19.625 16 19.625H5C4.10254 19.625 3.375 18.8975 3.375 18V2C3.375 1.10254 4.10254 0.375 5 0.375Z"
          fill="white"
          stroke="#C8D2E1"
          strokeWidth="0.75"
        />
        <path
          d="M11.5 0.5V5C11.5 5.82843 12.1716 6.5 13 6.5H17.5"
          stroke="#C8D2E1"
          strokeWidth="0.75"
          strokeLinecap="round"
        />
      </g>
      <rect x="0.5" y="9.5" width="12.25" height="8" rx="1" fill="#1819B4" />
      <path
        d="M2.26615 15.5V11.8636H3.70081C3.97661 11.8636 4.21158 11.9163 4.40571 12.0217C4.59984 12.1258 4.7478 12.2708 4.8496 12.4567C4.95258 12.6413 5.00408 12.8544 5.00408 13.0959C5.00408 13.3374 4.95199 13.5504 4.84783 13.7351C4.74366 13.9197 4.59274 14.0636 4.39506 14.1665C4.19856 14.2695 3.96063 14.321 3.68128 14.321H2.76686V13.7049H3.55699C3.70495 13.7049 3.82687 13.6795 3.92275 13.6286C4.01982 13.5765 4.09202 13.5049 4.13937 13.4137C4.18791 13.3214 4.21217 13.2154 4.21217 13.0959C4.21217 12.9751 4.18791 12.8698 4.13937 12.7798C4.09202 12.6887 4.01982 12.6183 3.92275 12.5685C3.82569 12.5176 3.70258 12.4922 3.55344 12.4922H3.03497V15.5H2.26615ZM6.69252 15.5H5.40345V11.8636H6.70317C7.06894 11.8636 7.3838 11.9364 7.64777 12.082C7.91174 12.2264 8.11475 12.4342 8.25679 12.7053C8.40002 12.9763 8.47164 13.3007 8.47164 13.6783C8.47164 14.0571 8.40002 14.3826 8.25679 14.6548C8.11475 14.9271 7.91056 15.136 7.64422 15.2816C7.37907 15.4272 7.06183 15.5 6.69252 15.5ZM6.17227 14.8413H6.66056C6.88783 14.8413 7.079 14.801 7.23406 14.7205C7.39031 14.6388 7.5075 14.5128 7.58563 14.3423C7.66494 14.1707 7.70459 13.9493 7.70459 13.6783C7.70459 13.4096 7.66494 13.19 7.58563 13.0195C7.5075 12.8491 7.39091 12.7236 7.23584 12.6431C7.08077 12.5626 6.8896 12.5224 6.66233 12.5224H6.17227V14.8413ZM8.94115 15.5V11.8636H11.3488V12.4975H9.70997V13.364H11.189V13.9979H9.70997V15.5H8.94115Z"
        fill="white"
      />
      <defs>
        <clipPath id="clip0_2967_33526">
          <rect width="15" height="20" fill="white" transform="translate(3)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DocumentWithLabelIcon;
